import { EmailDistributionModel } from 'api/dto/EmailDistribution.dto';
import { EmailTemplateModel } from 'api/dto/EmailTemplate.dto';
import { Resource } from 'model/Resource';
import { LangCodeEnum } from 'shared/enums/LangCodeEnum';

export const STORE_NAME = 'emailDistribution';

export namespace EmailDistributionState {
  export type EmailDistributionResource = Resource<EmailDistributionModel>;
  export type EmailTemplateByLanguage = Record<LangCodeEnum, EmailTemplateModel | null>;
  export type EmailTemplateByIdByLanguage = Record<
    EmailTemplateModel['id'],
    EmailTemplateByLanguage
  >;

  export type Domain = {
    distributionResource: EmailDistributionResource;
    emailTemplateByIdByLanguage?: EmailTemplateByIdByLanguage;
    currentEmailTemplate: EmailTemplateModel | null;
  };

  export const INITIAL_DOMAIN: Domain = {
    distributionResource: Resource.createPendingResource<EmailDistributionModel>(),
    emailTemplateByIdByLanguage: {} as EmailTemplateByIdByLanguage,
    currentEmailTemplate: null,
  };
}
